import { PatientActions } from 'src/redux/actions/constant';

const { SWITCH_THERAPIST_DISCIPLINE } = PatientActions;

const intitialstate = '';

export const switchDisciplineReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SWITCH_THERAPIST_DISCIPLINE: {
      return action.payload;
    }
    default:
      return state;
  }
};
